export const EDUCATION_LOADING = "EDUCATION_LOADING";
export const EDUCATION_RESET = "EDUCATION_RESET";
export const GET_EDUCATION = "GET_EDUCATION";
export const GET_EDUCATION_SUCCESS = "GET_EDUCATION_SUCCESS";
export const GET_EDUCATION_FAIL = "GET_EDUCATION_FAIL";
export const DELETE_EDUCATION = "DELETE_EDUCATION"
export const DELETE_EDUCATION_SUCCESS = "DELETE_EDUCATION_SUCCESS"
export const DELETE_EDUCATION_FAIL = "DELETE_EDUCATION_FAIL"
export const UPDATE_EDUCATION = "UPDATE_EDUCATION"
export const UPDATE_EDUCATION_SUCCESS = "UPDATE_EDUCATION_SUCCESS"
export const UPDATE_EDUCATION_FAIL = "UPDATE_EDUCATION_FAIL"
export const ADD_NEW_EDUCATION = "ADD_NEW_EDUCATION"
export const ADD_EDUCATION_SUCCESS = "ADD_EDUCATION_SUCCESS"
export const ADD_EDUCATION_FAIL = "ADD_EDUCATION_FAIL"